/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_FLOORMAPS (state, floormaps) {
    state.floormaps = floormaps
  },
  SET_BOOTHMAPS (state, boothmaps) {
    state.boothmaps = boothmaps
  },
  SET_ROOTMAPS (state, rootmaps) {
    state.rootmaps = rootmaps
  },
  REMOVE_RECORD (state, itemId) {
    const pageIndex = state.floormaps.findIndex((u) => u.ID === itemId)
    state.floormaps.splice(pageIndex, 1)
  }
}
